export var ACTIONS = /*#__PURE__*/function (ACTIONS) {
  ACTIONS["OPEN_TYPEAHEAD_AT_CURSOR"] = "OPEN_TYPEAHEAD_AT_CURSOR";
  ACTIONS["CLOSE_TYPE_AHEAD"] = "CLOSE_TYPE_AHEAD";
  ACTIONS["CHANGE_QUERY"] = "CHANGE_QUERY";
  ACTIONS["INSERT_ITEM"] = "INSERT_ITEM";
  ACTIONS["INSERT_RAW_QUERY"] = "INSERT_RAW_QUERY";
  ACTIONS["UPDATE_LIST_ITEMS"] = "UPDATE_LIST_ITEMS";
  ACTIONS["UPDATE_LIST_ERROR"] = "UPDATE_LIST_ERROR";
  ACTIONS["CLEAR_LIST_ERROR"] = "CLEAR_LIST_ERROR";
  ACTIONS["UPDATE_SELECTED_INDEX"] = "UPDATE_SELECTED_INDEX";
  return ACTIONS;
}({});